import Class from "../jquery_class";

export default Class.extend({
  init: function(id, name) {
    this.id = id;
    this.name = name;
  }
});
